import React, { useEffect, useState } from 'react';

import usePublicApi from 'public-api';

import Product from './Product';
import ProductsCardLoader from './ProductsCardLoader';

type Props = {
  ticket: BackendPublic.TicketDetail;
  products: BackendPublic.Products[];
};

function Products({ ticket, products }: Props) {
  const [productCustomFieldTypes, setProductCustomFieldTypes] = useState<
    BackendPublic.ClientProductCustomFieldType[] | null
  >(null);
  const api = usePublicApi();

  useEffect(() => {
    (async () => {
      const response = await api.ClientTicketProductCustomFieldTypesApi.list({ id: ticket.id });
      setProductCustomFieldTypes(response);
    })();
  }, [api.ClientTicketProductCustomFieldTypesApi, ticket.id]);

  if (products.length === 0) return null;

  if (productCustomFieldTypes === null) return <ProductsCardLoader />;

  return (
    <div className="space-y-4">
      {products.map((product) => (
        <Product key={product.id} product={product} ticket={ticket} productCustomFieldTypes={productCustomFieldTypes} />
      ))}
    </div>
  );
}

export default Products;
